var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "payload" }, [
    _c(
      "div",
      {
        staticClass:
          "d-flex align-items-center align-content-center justify-content-start",
      },
      [
        _c("BlockPicker", {
          attrs: {
            "flatted-diagram": _vm.flattedDiagram,
            isGotoStep: _vm.isGotoStep,
          },
          model: {
            value: _vm.payload.blockId,
            callback: function ($$v) {
              _vm.$set(_vm.payload, "blockId", $$v)
            },
            expression: "payload.blockId",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }